import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Styles from 'components/modal/Modal.module.scss';
import { Portal } from 'components/general/Portal';
import { ModalDialog } from 'components/modal/ModalDialog';

export class Modal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: this.props.visible || false,
      backdrop: false,
      contents: false,
      transitioning: false,
    };
  }

  componentDidMount() {
    this.props.visible === true ? this._onShow() : this._onHide();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.visible !== this.props.visible) {
      this.props.visible === true ? this._onShow() : this._onHide();
    }
  }

  render() {
    const { props, state } = this;

    if (props.visible === false && state.backdrop === false) {
      return null;
    }

    let _attributes = {},
      _cls =
        props.className != ''
          ? [Styles[props.className]]
          : [Styles['modal__wrap']],
      _clsContents = [Styles['modal__contents']];

    if (state.transitioning) _cls.push(Styles['fade']);
    if (state.backdrop) _cls.push(Styles['show']);
    if (state.contents) _clsContents.push(Styles['show']);

    _attributes.id = props.id ? props.id : 'gb-modal-' + Date.now();
    _attributes.className = classnames(_cls);

    return (
      <Portal {..._attributes}>
        <div className={classnames(_clsContents)}>
          {this._renderChildren()}
          {this._renderCloseButton()}
        </div>
        <div
          className={Styles['modal__backdrop']}
          onClick={this._backdropClick}
        />
      </Portal>
    );
  }

  // --------------------------------------------------------------------

  _backdropClick = () => {
    if (this.state.transitioning === false) {
      if (this.props.disableBackdropClose === false) {
        this.props.onCloseModal();
      }
    }
  };

  _closeButtonClick = () => {
    if (this.state.transitioning === false) {
      this.props.onCloseModal();
    }
  };

  _onHide = () => {
    this.setState(
      {
        contents: false,
        transitioning: true,
      },
      () => {
        setTimeout(() => {
          this.setState({
            backdrop: false,
            transitioning: false,
          });
        }, 300);
      }
    );
  };

  _onShow = () => {
    this.setState(
      {
        backdrop: true,
        transitioning: true,
      },
      () => {
        setTimeout(() => {
          this.setState({
            contents: true,
            transitioning: false,
          });
        }, 300);
      }
    );
  };

  _renderChildren = () => {
    const { props } = this;

    if (this.props.useDefaultDialog === true) {
      return <ModalDialog>{props.children}</ModalDialog>;
    }

    return props.children;
  };

  _renderCloseButton = () => {
    if (this.props.showCloseButton === false) return null;

    return (
      <button
        className={Styles['modal__close']}
        onClick={this._closeButtonClick}
      >
        &times;
      </button>
    );
  };
}

Modal.defaultProps = {
  id: '',
  className: '',
  children: null,
  disableBackdropClose: false,
  showCloseButton: true,
  useDefaultDialog: true,
};

Modal.propTypes = {
  id: PropTypes.string,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  children: PropTypes.node,
  showCloseButton: PropTypes.bool,
  useDefaultDialog: PropTypes.bool,
  disableBackdropClose: PropTypes.bool,
  visible: PropTypes.bool.isRequired,
  onCloseModal: PropTypes.func.isRequired,
};
